import React from 'react';
import { IconHelper } from '../../generic/IconHelper';
import type { RecentStoryTemplate } from 'components/editorial/AssetQuickLaunch/useRecentStoryTemplates';
import { makeTemplateKey, PlusNavObj } from './types';

// Preset some of a component's props and return a component that takes the rest.
// Shared so PlusButton's menu items and the template adapter build icons the
// same way.
export const ComponentWithProps = <P extends object>(
  Component: React.ComponentType<P>,
  props: P,
): React.ComponentType<P> => {
  return (additionalProps: P) => (
    <Component
      {...props}
      {...additionalProps}
    />
  );
};

// Adapt a story template into the same PlusNavObj shape apps use, so the Create
// menu can render templates with DnDBasePlusNavItem (shared with Recommended /
// Pinned) and pin them through the same handlers.
export const templateToPlusNavObj = (
  template: RecentStoryTemplate,
  untitledLabel: string,
): PlusNavObj => ({
  key: makeTemplateKey(template.uuid),
  label: template.title || untitledLabel,
  action: 'template',
  icon: ComponentWithProps(IconHelper, { iconType: template.type || 'template' }),
  keywords: ['template', 'asset', 'editorial'],
  template,
});
